import { LitElement, css, html } from 'lit'
import {
  kulaCat,
  sleepyKulaCat,
  searchKulaCat,
  fixItKulaCat,
  kulaCatWarning,
} from '../../../../shared/assets/svg/kula-cat/kula-cat.js'

class kulaKatMessage extends LitElement {
  static properties = {
    message: { type: String },
    bodyText: { type: String },
    title: { type: String },
    catType: { type: Number },
    kulaCat: { type: Object },
  }

  constructor() {
    super()
    this.title = ''
    this.message = ''
    this.bodyText = ''
    this.catType = 1
    this.kulaCat = {
      1: kulaCat,
      2: sleepyKulaCat,
      3: searchKulaCat,
      4: fixItKulaCat,
      5: kulaCatWarning,
    }
  }

  render() {
    return html`
      <div class="error-message-wrapper">
        <h1>${this.title}</h1>
        <p>${this.bodyText}</p>
        ${this.kulaCat[this.catType]}
        <p><slot></slot></p>
      </div>
    `
  }
  static styles = css`
    .error-message-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;
      padding: 32px;
    }
    .error-message-wrapper > svg {
      height: 160px;
    }
    .error-message-wrapper > h1 {
      text-align: center;

      /* Heading1 */
      font-family: Lato;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      letter-spacing: 0.024px;
      color: var(--kula-deep-green);
    }
    .error-message-wrapper > p {
      color: var(--kula-deep-green);
      text-align: center;
      /* DialogueMessage */
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 125% */
      letter-spacing: 0.016px;
      width: 320px;
    }
  `
}

export default kulaKatMessage
customElements.define('kula-cat-message', kulaKatMessage)
